// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {}

export const taskNotice = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/task-notice/task-notice.store.js